import { render, staticRenderFns } from "./ReviewAutomatedInvestmentFunding.vue?vue&type=template&id=d9e71910"
import script from "./ReviewAutomatedInvestmentFunding.vue?vue&type=script&lang=ts"
export * from "./ReviewAutomatedInvestmentFunding.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports